import { render, staticRenderFns } from "./UTMCreationDialog.vue?vue&type=template&id=daf36796&scoped=true"
import script from "./UTMCreationDialog.vue?vue&type=script&lang=js"
export * from "./UTMCreationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf36796",
  null
  
)

export default component.exports